import { Link } from "react-router-dom";
import { Zap, Smartphone, MousePointerClick, Gauge, Check, ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/Section";
import { useI18n } from "@/context/I18nContext";

const features = [
  { icon: Zap, k: "lp.f1" }, { icon: Smartphone, k: "lp.f2" },
  { icon: MousePointerClick, k: "lp.f3" }, { icon: Gauge, k: "lp.f4" },
];

export default function LandingPages() {
  const { t } = useI18n();
  return (
    <div>
      <section className="section-lux grid-glow text-center">
        <div className="container-lux max-w-3xl">
          <div className="label-lux mb-3">{t("lp.label")}</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white">{t("lp.h1a")}<span className="gold-text">{t("lp.h1b")}</span></h1>
          <p className="mt-6 text-slate-400 text-lg">{t("lp.sub")}</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/services/landing-page-development" className="gold-btn" data-testid="landing-order-button">{t("lp.cta1")} <ArrowRight size={16} /></Link>
            <Link to="/contact" className="silver-btn">{t("lp.cta2")}</Link>
          </div>
        </div>
      </section>
      <section className="section-lux bg-[#0e1013] border-y border-amber-500/10">
        <div className="container-lux">
          <SectionHeading label={t("lp.secLabel")} title={t("lp.secTitle")} />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((f, i) => (
              <div key={i} className="card-lux p-6 fade-up" style={{ animationDelay: `${i * 60}ms` }}>
                <f.icon className="text-amber-400 mb-4" size={24} />
                <h3 className="font-semibold text-white mb-2">{t(f.k + "t")}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{t(f.k + "d")}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
